<template>
  <div class="DeviceIcon">
    <el-tooltip
      :content="typeFormatted"
      placement="top"
    >
      <component
        :is="`icon-${props.type}`"
        class="w-full"
      />
    </el-tooltip>
  </div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'web',
  },
});

// Computed
const typeFormatted = computed(() => {
  if (props.type === 'ios') {
    return 'iOS';
  }

  return _capitalize(props.type);
});
</script>

<style setup>
@reference "assets/css/tailwind.css";

.DeviceIcon {
  @apply text-muted w-4 h-auto flex items-center;
}
</style>
